<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 34.97 38.94" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linejoin="round"><path d="m9.82 9 4 29.41h12.61l3.36-29.41z"/><circle cx="9.82" cy="9.82" r="9.32"/><path d="m10.8 16.2h18.2"/><path d="m16.77 34.17 11.23-32.55 6.73 3.59"/><circle cx="6.16" cy="12.88" r=".39"/><circle cx="4.33" cy="9.03" r=".39"/><circle cx="6.16" cy="5.6" r=".39"/><circle cx="9.82" cy="3.71" r=".39"/><circle cx="13.48" cy="5.6" r=".39"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
